export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-male-8521ed40c232516eacdc781cb58ee062.svg";